import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { type RecommendationAttributionContext } from './recommendationAttributionProductType'

type RecommendationAttributionRecommendedProduct = Pick<
  GkAirRecommendedProductDataWeb,
  'brand' | 'seller_id' | 'UID'
>

/**
 * Maps a recommended product to the provider-independent attribution context.
 */
export const recommendationAttributionFromRecommendedProduct = (
  product?: RecommendationAttributionRecommendedProduct,
): RecommendationAttributionContext | undefined => {
  if (!product) {
    return undefined
  }

  return {
    brandName: product.brand,
    productId: product.UID,
    sellerId: product.seller_id,
  }
}
